import { type DesignElementBase } from "..";
import { createIcon } from "../design-element-utils";

const designElement: DesignElementBase = {
  tags: [
    "Affiliate ",
    "Affiliate 2",
    "Affiliate",
    "Affiliate/Referral",
    "Affiliates",
    "Other Affiliate",
    "Other Affiliates",
  ],
  iconColor: "#5CBF64", // alien
  getIcon(options) {
    return createIcon(
      `
      <path
      d="M5.98438 11.2422L8.65625 8.59375C9.96875 7.28125 12.1016 7.28125 13.4141 8.59375C14.6797 9.83594 14.75 11.8516 13.5781 13.1875L13.4375 13.3281L12.5938 12.6016L12.7344 12.4609C13.5078 11.5703 13.4609 10.2344 12.6172 9.39062C11.75 8.5 10.3203 8.5 9.45312 9.39062L6.78125 12.0391C5.91406 12.9297 5.91406 14.3359 6.78125 15.2266C7.625 16.0469 8.96094 16.0938 9.85156 15.3203L9.99219 15.2031L10.7422 16.0469L10.6016 16.1641C9.26562 17.3359 7.25 17.2656 5.98438 16.0234C4.67188 14.7109 4.67188 12.5547 5.98438 11.2422ZM18.1953 11.7812L15.5469 14.4297C14.2109 15.7422 12.0781 15.7422 10.7656 14.4297C9.52344 13.1641 9.45312 11.1719 10.625 9.83594L10.7188 9.69531L11.5625 10.4453L11.4688 10.5625C10.6719 11.4531 10.7188 12.7891 11.5625 13.6328C12.4297 14.5 13.8594 14.5 14.75 13.6328L17.3984 10.9844C18.2656 10.0938 18.2656 8.6875 17.3984 7.79688C16.5547 6.95312 15.2188 6.92969 14.3281 7.70312L14.1875 7.82031L13.4375 6.97656L13.5781 6.85938C14.9141 5.6875 16.9297 5.75781 18.1953 7C19.5078 8.3125 19.5078 10.4453 18.1953 11.7812Z"
      fill="#5CBF64" />
      `,
      "#EFF9EF", // alien-2
      options?.borderColor || "#E0E2E6",
      options?.size || "24",
    );
  },
};

export default designElement;
